package com.anjuros.website.redesign.sections.faq

import androidx.compose.runtime.Composable
import com.anjuros.website.redesign.components.RdClosingCard
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText

@Composable
fun FaqClosingSection() {
    RdClosingCard(
        RdText.FAQS_CLOSE_EYEBROW, RdText.FAQS_CLOSE_TITLE, RdText.FAQS_CLOSE_LEDE,
        secondaryText = RdText.FAQS_CLOSE_PRICING, secondaryPath = RdRoute.PRICING,
    )
}
